'use client'

import { cn } from '@/lib/utils'
import { AudioAssetsLayoutPreference } from '@/lib/store/store'
import { LayoutGrid, List } from 'lucide-react'

type AudioLayoutToggleProps = {
  value: AudioAssetsLayoutPreference
  onChangeAction: (value: AudioAssetsLayoutPreference) => void
  className?: string
}

const options: Array<{
  label: string
  value: AudioAssetsLayoutPreference
  icon: typeof List
}> = [
  {
    label: 'Rows',
    value: 'row',
    icon: List,
  },
  {
    label: 'Grid',
    value: 'grid',
    icon: LayoutGrid,
  },
]

export default function AudioLayoutToggle({ value, onChangeAction, className }: AudioLayoutToggleProps) {
  return (
    <div className={cn('tw-flex tw-items-center tw-gap-2', className)}>
      <span className="body_3 tw-text-[var(--Primary-300)]">View</span>
      <div className="tw-inline-flex tw-items-center tw-gap-1 tw-rounded-lg tw-border tw-border-[var(--Primary-400)] tw-bg-[var(--Primary)] tw-p-1">
        {options.map((option) => {
          const Icon = option.icon
          const active = option.value === value

          return (
            <button
              key={option.value}
              type="button"
              title={`Show audio assets as ${option.label.toLowerCase()}`}
              aria-label={`Show audio assets as ${option.label.toLowerCase()}`}
              aria-pressed={active}
              className={cn(
                'tw-inline-flex tw-items-center tw-gap-2 tw-rounded-lg tw-px-2 tw-py-1 tw-text-sm tw-transition-colors',
                'focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[var(--Secondary)] focus-visible:tw-ring-offset-2 focus-visible:tw-ring-offset-[var(--Primary)]',
                {
                  'tw-bg-[var(--Primary-400)] tw-text-[var(--Secondary-100)]': active,
                  'tw-text-[var(--Primary-300)] hover:tw-bg-[var(--Primary-400)] hover:tw-text-[var(--Primary-100)]':
                    !active,
                }
              )}
              onClick={() => onChangeAction(option.value)}
            >
              <Icon className="tw-h-4 tw-w-4" />
              <span>{option.label}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}
